export const LOGIN_TYPE_CODE = {
    OTP: 'otp',
    LOGIN_PASSWORD: 'loginPassword',
} as const;

export type LoginTypeCode = (typeof LOGIN_TYPE_CODE)[keyof typeof LOGIN_TYPE_CODE];

export const OTP_TYPE_CODE = {
    EMAIL: 'email',
    PHONE: 'phone',
} as const;

export type OtpTypeCode = (typeof OTP_TYPE_CODE)[keyof typeof OTP_TYPE_CODE];
